import './CopyPageTitleA.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';

export interface CopyPageTitleAContentType {
  subTitle?: string;
  title?: string;
}

interface CopyPageTitleAProps extends CopyPageTitleAContentType {
  mainComponent?: boolean;
}

export const CopyPageTitleA = ({ mainComponent, subTitle, title }: CopyPageTitleAProps) => {
  return (
    <div className="copy-page-title-a">
      <Container>
        <b2x.Div display={'flex'} flexDirection={'column'} gap={3} textAlign="center">
          <b2x.ConditionalWrapper
            condition={!!title}
            wrapper={
              mainComponent ? (
                <b2x.H1 className="text-white display-1 fw-bold copy-title" marginBottom={0} />
              ) : (
                <b2x.H3 className="text-white display-1 fw-bold copy-title" marginBottom={0} />
              )
            }
          >
            {b2x.formatHtml(title)}
          </b2x.ConditionalWrapper>
          {subTitle && (
            <b2x.H4
              className="text-white fw-light h2 copy-description"
              marginBottom={0}
              style={{ textWrap: 'balance' }}
            >
              {b2x.formatHtml(subTitle)}
            </b2x.H4>
          )}
        </b2x.Div>
      </Container>
    </div>
  );
};
